(() => {
  if (window.gastroCartDiscountBound) return;
  window.gastroCartDiscountBound = true;
  const fi = document.documentElement.lang.startsWith('fi');
  const text = (en, fin) => fi ? fin : en;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-cart-discount]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('input'), button = form.querySelector('button'), status = form.querySelector('[data-discount-status]');
    const code = input.value.trim();
    if (!code || button.disabled) return;
    button.disabled = true;
    status.textContent = text('Checking code…', 'Tarkistetaan koodia…');
    const root = window.Shopify?.routes?.root || '/';
    try {
      const currentResponse = await fetch(root + 'cart.js');
      if (!currentResponse.ok) throw new Error();
      const current = await currentResponse.json();
      const existing = (current.discount_codes || []).filter(d => d.applicable).map(d => d.code);
      const codes = [...new Set([...existing, code])];
      const sectionIds = [document.querySelector('#main-cart-items')?.dataset.id, document.querySelector('#main-cart-footer')?.dataset.id].filter(Boolean);
      const response = await fetch(root + 'cart/update.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({discount:codes.join(','),sections:sectionIds,sections_url:location.pathname})});
      if (!response.ok) throw new Error();
      const cart = await response.json();
      const matched = (cart.discount_codes || []).find(d => d.code.toLowerCase() === code.toLowerCase());
      for (const id of sectionIds) {
        const html = cart.sections?.[id];
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html,'text/html');
        for (const selector of ['#main-cart-items .js-contents','#main-cart-footer .js-contents']) {
          const next = doc.querySelector(selector), target = document.querySelector(selector);
          if (next && target) target.innerHTML = next.innerHTML;
        }
      }
      status.textContent = matched?.applicable ? text('Discount applied.', 'Alennus käytössä.') : text('This code cannot be applied to this cart. Check the code and its conditions.', 'Koodia ei voi käyttää tähän ostoskoriin. Tarkista koodi ja sen ehdot.');
      window.dispatchEvent(new Event('gastro:cart-updated'));
    } catch {
      status.textContent = text('Unable to check the code. Please try again.', 'Koodin tarkistus epäonnistui. Yritä uudelleen.');
    } finally { button.disabled = false; }
  });
})();
